import AppSettings from "../../../../Settings/AppSettings";
import React, { useContext, useEffect, useState } from "react";
import { CategoryContext } from "../CategoryContext";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import Label from "../../../Common/components/Label";
import { useHistory } from "react-router-dom";

const AssociatedRules = () => {
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const history = useHistory();
  const categoryTypeContextData = useContext(CategoryContext);
  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const [collapse, setCollapse] = useState(false);
  let [associatedRules, setAssociatedRules] = useState(null);

  async function load_associated_Rules() {
    setLoading({ status: "loading", message: "Loading Associated Rules" });
    let res = await ServiceWrapper.doGet(
      `${api_base_url}category/${categoryTypeContextData.editingItem.id}/associatedrules/list`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      setLoading({ status: "success", message: "" });
      setAssociatedRules(res.data.data);
    } else {
      setLoading({ status: "Error", message: "Error while loading details" });
    }
  }

  function handle_collapse() {
    setCollapse(!collapse);
  }

  useEffect(() => {
    setAssociatedRules(null);
    setLoading({
      status: "",
      message: "",
    });
  }, [categoryTypeContextData.editingItem.id]);

  useEffect(() => {
    if (associatedRules === null && collapse) {
      load_associated_Rules();
    }
  }, [collapse]);

  return (
    <>
      <div className="accordion" id="accordionFlushRules">
        <div className="accordion-item">
          <div
            className="bg-white shadow-none accordion-button collapsed"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapseRules"
            aria-controls="flush-collapseRules"
            // style={Utils.borderStyle()}
            style={{
              height: "2.6875rem",
              // border: "1px solid #c9cccf"
            }}
          >
            <div style={{ width: "96%" }}>
              <Label message="Associated Rules" />
            </div>
          </div>
          {collapse && loading.status === "success" && (
            <div
              className="d-inline-block float-end position-relative"
              style={{ zIndex: "100", marginTop: "-34px", marginRight: "30px" }}
            >
              <button
                type="button"
                className="btn btn-light btn-sm"
                style={{
                  color: "#091caa",
                  background: "none",
                  border: "none",
                  boxShadow: "none",
                }}
                onClick={() => {
                  load_associated_Rules();
                }}
              >
                <i
                  className="fa fa-sync-alt"
                  style={{
                    color: "#091caa",
                    fontSize: "0.875rem",
                  }}
                />
              </button>
            </div>
          )}
          <div
            id="flush-collapseRules"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingRules"
            data-bs-parent="#accordionFlushRules"
          >
            <div
              className="accordion-body"
              style={{ minHeight: "100px", padding: "0px" }}
            >
              {loading.status === "loading" && (
                <div
                  className="p-2 bg-white alert alert-primary small"
                  role="alert"
                >
                  <span className="fas fa-circle-notch fa-spin" />
                  &nbsp;
                  <strong>{loading.message}</strong>
                </div>
              )}

              {loading.status === "success" && (
                <>
                  {associatedRules && associatedRules.length > 0 ? (
                    <div>
                      <div className="table-responsive">
                        <table className="table table-sm">
                          <thead>
                            <tr
                              style={{
                                background: "#f2f2f2",
                                border: "1px solid #c9cccf",
                                height: "43",
                                fontFamily: "Noto Sans",
                                fontWeight: 400,
                                margin: "42px 0 12px",
                                color: "#5c5f62",
                                borderRight: "none",
                                borderLeft: "none",
                              }}
                            >
                              <th
                                className="border-0"
                                scope="col"
                                width="35%"
                                style={{
                                  height: "43",
                                  fontFamily: "Noto Sans",
                                  fontWeight: 400,
                                  padding: "13px 31px 11px 20px",
                                }}
                              >
                                NAME / EFFECTIVE FROM
                              </th>
                              <th
                                className="border-0"
                                scope="col"
                                width="10%"
                                style={{
                                  height: "43",
                                  fontFamily: "Noto Sans",
                                  fontWeight: 400,
                                  padding: "13px 31px 11px 20px",
                                }}
                              >
                                TYPE
                              </th>
                              <th
                                className="border-0"
                                scope="col"
                                style={{
                                  height: "43",
                                  fontFamily: "Noto Sans",
                                  fontWeight: 400,
                                  padding: "13px 31px 11px 20px",
                                }}
                              >
                                CATEGORY 1
                              </th>
                              <th
                                className="border-0"
                                scope="col"
                                style={{
                                  height: "43",
                                  fontFamily: "Noto Sans",
                                  fontWeight: 400,
                                  padding: "13px 31px 11px 20px",
                                }}
                              >
                                CATEGORY 2
                              </th>
                              <th
                                className="border-0"
                                scope="col"
                                style={{
                                  height: "43",
                                  fontFamily: "Noto Sans",
                                  fontWeight: 400,
                                  padding: "13px 31px 11px 20px",
                                }}
                              >
                                COMMITTED
                              </th>
                            </tr>
                          </thead>
                          {associatedRules.map((i, index) => {
                            return (
                              <tbody
                                key={i.id}
                                style={{
                                  backgroundColor:
                                    index % 2 === 0 ? "white" : "white",
                                }}
                              >
                                <tr className="border-1" key={index}>
                                  <th
                                    className="align-middle border-0 "
                                    onClick={() => {
                                      history.push({
                                        pathname: `/gms/rule/edit/${i.id}`,
                                      });
                                    }}
                                    style={{
                                      height: "43",
                                      fontFamily: "Noto Sans",
                                      cursor: "pointer",
                                      fontWeight: 400,
                                      padding: "13px 31px 11px 20px",
                                    }}
                                  >
                                    {/* {i.active ? (
                                      <span className="green-dot"> </span>
                                    ) : (
                                      <span className="red-dot"> </span>
                                    )}
                                    &nbsp; */}
                                    <Label
                                      onClick={() => {
                                        history.push({
                                          pathname: `/gms/rule/edit/${i.id}`,
                                        });
                                      }}
                                      message={i.name}
                                      fontSize={0.875}
                                      fontWeight="400"
                                      fontFamily="Noto Sans"
                                    />

                                    {/* {i.name} */}
                                    <br />

                                    {/* <span className="text-black bg-white border rounded badge border-dark text-muted"> */}
                                    <Label
                                      message={i.created_on}
                                      fontSize={0.7}
                                      fontWeight="300"
                                      fontFamily="Noto Sans"
                                    />
                                    {/* {i.created_on} */}
                                    {/* </span> */}
                                  </th>
                                  <td
                                    className="align-middle border-0"
                                    style={{
                                      height: "43",
                                      fontFamily: "Noto Sans",
                                      fontWeight: 400,
                                      padding: "13px 31px 11px 20px",
                                    }}
                                  >
                                    <span className="border-0 rounded badge text-dark">
                                      <Label
                                        message={i.type}
                                        fontSize={0.875}
                                        fontWeight="400"
                                        fontFamily="Noto Sans"
                                      />
                                    </span>
                                  </td>
                                  <td
                                    className="align-middle border-0"
                                    style={{
                                      height: "43",
                                      fontFamily: "Noto Sans",
                                      fontWeight: 400,
                                      padding: "13px 31px 11px 20px",
                                    }}
                                  >
                                    {/* <span className="border rounded badge bg-primary border-dark">
                                      LEFT&nbsp;&nbsp;&nbsp;
                                    </span>
                                    &nbsp; */}
                                    <Label
                                      message={i.left_category_name}
                                      fontSize={0.875}
                                      fontWeight="400"
                                      fontFamily="Noto Sans"
                                    />
                                    {/* {i.left_category_name} */}
                                    {/* <br />
                                    <span className="border rounded badge bg-secondary border-dark">
                                      RIGHT
                                    </span>
                                    &nbsp;
                                    <Label
                                      message={i.right_category_name}
                                      fontSize={0.8}
                                      fontWeight="600"
                                    /> */}
                                    {/* {i.right_category_name} */}
                                  </td>
                                  <td
                                    className="align-middle border-0"
                                    style={{
                                      height: "43",
                                      fontFamily: "Noto Sans",
                                      fontWeight: 400,
                                      padding: "13px 31px 11px 20px",
                                    }}
                                  >
                                    <Label
                                      message={i.right_category_name}
                                      fontSize={0.875}
                                      fontWeight="400"
                                      fontFamily="Noto Sans"
                                    />
                                  </td>
                                  <td
                                    className="align-middle border-0"
                                    style={{
                                      height: "43",
                                      fontFamily: "Noto Sans",
                                      fontWeight: 400,
                                      padding: "13px 31px 11px 20px",
                                    }}
                                  >
                                    <Label
                                      message={i.committed ? "Yes" : "No"}
                                      fontSize={0.875}
                                      fontWeight="400"
                                      fontFamily="Noto Sans"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            );
                          })}
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="p-2 m-3 bg-white alert alert-dark small"
                      role="alert"
                    >
                      <strong>Associated Rules Not Found</strong>
                    </div>
                  )}
                </>
              )}
              {loading.status === "Error" && (
                <div className="p-2 alert alert-danger small" role="alert">
                  <span className="fas fa-exclamation-triangle" />
                  &nbsp;
                  <strong>{loading.message}</strong>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AssociatedRules;
